// extracted by mini-css-extract-plugin
export default {"SecondaryContainer":"ChannelVideos_SecondaryContainer__Wyee6","PrimaryContainer":"ChannelVideos_PrimaryContainer__FVfor","NoDataAvailable":"ChannelVideos_NoDataAvailable__Udq+v"};